import { render, staticRenderFns } from "./SuggestionSolution.vue?vue&type=template&id=31d2db96&"
import script from "./SuggestionSolution.vue?vue&type=script&lang=js&"
export * from "./SuggestionSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports